"use client"

import type { PostSessionRequest } from "@/api"
import { isAxiosError } from "axios"
import { useRouter } from "next/navigation"
import {
  Button,
  Field,
  Input,
  PasswordInput,
  useAsyncCallback,
  useNotice,
  VStack,
} from "@/components/ui"
import { CONSTANT } from "@/constant"
import { api } from "@/libs/axios"
import { useForm } from "@/libs/react-hook-form"
import { isCenter } from "@/utils/app"
import { replaceMessage } from "@/utils/string"

interface FieldValues extends PostSessionRequest {}

export function Form() {
  const router = useRouter()
  const notice = useNotice()
  const {
    formState: { errors },
    handleSubmit,
    register,
    setAPIErrors,
    setValue,
  } = useForm<FieldValues>()

  const [loading, onSubmit] = useAsyncCallback(
    async (fieldValues: FieldValues) => {
      try {
        const { data } = await api.postSession(fieldValues)

        if (data.payload.require_reset_password) {
          // TODO: パスワードの初回設定に遷移する。
        } else if (data.payload.permissions) {
          if (isCenter(data.payload.permissions)) {
            router.push("/admins/center/dashboard")
          } else {
            router.push("/admins/members/dashboard")
          }
        }

        notice({
          status: "success",
          title: replaceMessage(CONSTANT.MESSAGE.SUCCESS.DONE, "ログイン"),
        })
      } catch (e) {
        setValue("password", "")

        if (isAxiosError(e)) setAPIErrors(e)
      }
    },
    [],
    { loading: "page" },
  )

  return (
    <VStack as="form" noValidate onSubmit={handleSubmit(onSubmit)}>
      <VStack gap="md">
        <Field.Root
          errorMessage={errors.email?.message}
          invalid={!!errors.email}
          label="メールアドレス"
          required
        >
          <Input autoComplete="email" {...register("email")} />
        </Field.Root>

        <Field.Root
          errorMessage={errors.password?.message}
          invalid={!!errors.password}
          label="パスワード"
          required
        >
          <PasswordInput
            autoComplete="current-password"
            {...register("password")}
          />
        </Field.Root>
      </VStack>

      <Button type="submit" size="lg" loading={loading}>
        ログイン
      </Button>
    </VStack>
  )
}
